<template>
  <div class="el-progress-step">
    <div class="progress-inner">
      <div class="box"
           v-for="(box,index) in stepsFlowCopy"
           :key="index"
           :class="{'box-sucess1': box.status === 1,'box-sucessing1': (index > 0) && (index-1 >= 0) && (stepsFlowCopy[index-1].status === 1)}">
        <div class="el-help-circle"
             :class="{'el-help-circle-sucess1': box.status === 1,'el-help-circle-sucessing1': box.status === 2}">
          <img v-if="box.status === 1"
               src="../../../../static/img/right.svg"
               class="right-icon">
          <span v-if="box.status === 2 || box.status === 3"
                :class="{'circle-text-finish1':box.status === 3,'circle-text1':true}">{{index+1}}</span>
          <img v-if="box.status === 4"
               src="../../../../static/img/minus.svg"
               class="minus-icon">
          <img v-if="box.status === 5"
               src="../../../../static/img/reject.svg"
               class="reject-icon">
        </div>
        <span class="el-helpprogress-text1"
              :class="{'el-helpprogress-text-sucess1': box.status === 1 || box.status === 2}">{{box.desc}}</span>
      </div>
    </div>
    <slot></slot>
    <!-- 使用方法 -->
    <!-- <ticket-steps :stepsFlow="worksheetDetail.userFlowChart">
      <div class="reject-info" v-if="worksheetDetail.breakReasonType">
        <el-alert v-if="worksheetDetail.breakReasonType == $t('ticket.cancelReason')" :title="(worksheetDetail.breakReason ? worksheetDetail.breakReason: '--')" type="warning" :closable="false"></el-alert>
        <el-alert v-else :title="worksheetDetail.breakReasonType + ':' + (worksheetDetail.breakReason ? worksheetDetail.breakReason: '--')" type="warning" :closable="false"></el-alert>
      </div>
    </ticket-steps> -->
  </div>
</template>
<script>
export default {
  props: {
    stepsFlow: {
      type: Array,
      default () { return []; },
      required: true
    }
  },
  computed: {
    stepsFlowCopy () {
      return $.extend(true, [], this.stepsFlow);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-progress-step {
  display: flex;
  justify-content: center;
  border-top: 2px solid #e7eaec;
  padding: 12px 0;
  background: #fff;
  overflow: hidden;
  color: #666;
  border: none;
  flex-direction: column;
  flex-wrap: nowrap;
  .progress-inner {
    display: flex;
    flex: 1;
    align-items: center;
    background: #fff;
    margin-top: 30px;
  }
  // 画圆圈
  .el-help-circle {
    width: 32px;
    height: 32px;
    border: 1px solid #d8d8d8;
    border-radius: 100%;
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    margin-bottom: 5px;
    color: #787a7a;
  }
  // 已完成 圆圈 绿色
  .el-help-circle.el-help-circle-sucess1 {
    //background: #2C68FF;
    border-color: #2aafff;
    color: #fff;
  }
  // 已完成 后版条线 绿色
  .box-sucess1::after {
    border-color: #2aafff !important;
  }
  .box-sucessing1::before {
    border-color: #2aafff !important;
  }
  // 进行中有背景色
  .el-help-circle.el-help-circle-sucessing1 {
    background: #2aafff;
    border-color: #2aafff;
    color: #fff;
  }
  // 统一字体 灰色
  .el-helpprogress-text1 {
    color: #999999;
    display: inline-block;
    height: 40px;
    display: inline-block;
    text-align: center;
    height: 40px;
    padding: 20px 0 0px 0;
  }
  // 已完成 进行中 字体黑色
  .el-helpprogress-text1.el-helpprogress-text-sucess1 {
    color: black;
  }
  .circle-text1 {
    font-size: 16px;
    color: #fff;
  }
  .circle-text-finish1 {
    color: #d8d8d8 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/TicketSteps.vue